document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 1051) {
    const swiperEl = document.querySelector(".announcement-swiper");

    if (swiperEl) {
      const autoRotate = swiperEl.dataset.autoRotate === "true";
      const changeSpeed = parseInt(swiperEl.dataset.changeSpeed, 10) * 1000;

      new Swiper(".announcement-swiper", {
        loop: true,
        autoplay: autoRotate
          ? {
              delay: changeSpeed,
              disableOnInteraction: false,
            }
          : false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          750: {
            slidesPerView: 2,
          },
        },
      });
    }
  }
});
